import AnimatedHeight from './animatedHeight';

export default AnimatedHeight;
